import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query } from '@syncfusion/ej2-data';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';

import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';
import { GridPageSettings, MenuFuncionCodes, SearchIncidenciaUsuarioItemDto, SearchIncidenciaUsuarioRequestDto, SearchIncidenciaUsuarioCategoriaRequest, IncidenciaUsuarioCategoria, SearchComunidadRequest, LocalStorageKeys, Comunidad } from '../../../../../src/app/shared/model';
import { MenuFuncionService, IncidenciaUsuarioService, IncidenciaUsuarioCategoriaService, ComunidadService } from '../../../../../src/app/shared/services/index';
import { ExportMediaTypeConstants } from '../../../shared/model';

@Component({
    selector: 'app-incidenciaUsuarioLista',
    templateUrl: './incidenciaUsuarioLista.component.html',
    styleUrls: ['./incidenciaUsuarioLista.component.scss']
})

export class IncidenciaUsuarioListaComponent implements OnInit {

    @ViewChild('grid')
    public grid: GridComponent;

    public data: DataManager;
    total: number = 0;
    searchForm: FormGroup;

    isValidating: boolean = false;
    isSearching: boolean = false;
    isExporting: boolean = false;
    canEdit: boolean = false;
    canView: boolean = false;
    verEnviados: boolean = false;
    verSoloNoLeidos: boolean = false;

    isComunidadSearching: boolean = false;
    categoriaList: IncidenciaUsuarioCategoria[];

    isCategoriaSearching: boolean = false;
    comunidadList: Comunidad[];

    public query: Query;

    public selectionOptions: SelectionSettingsModel;
    public pageSizes: number[];
    public toolbarOptions: ToolbarItems[];
    public pageSettings: PageSettingsModel;

    constructor(
        private formBuilder: FormBuilder,
        public dialog: MatDialog,
        private sharedFunctions: SharedFunctions,
        private router: Router,
        private route: ActivatedRoute,
        private menuService: MenuFuncionService,
        private categoriaService: IncidenciaUsuarioCategoriaService,
        private comunidadService: ComunidadService,
        private service: IncidenciaUsuarioService,
        private datePipe: DatePipe) {

    }

    ngOnInit(): void {
        this.isValidating = true;
        this.menuService.checkMenuPadre(MenuFuncionCodes.INCIDENCIA_USUARIO).subscribe(data => {
            this.isValidating = false;
            if (data != null && data.Success && data?.Result){
              this.canEdit = data.Result.some(x => x == MenuFuncionCodes.INCIDENCIA_USUARIO_EDIT);
              this.canView = data.Result.some(x => x == MenuFuncionCodes.INCIDENCIA_USUARIO_LIST);
                if (this.canView){
                  this.loadView();
                } else {
                  this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
                  this.router.navigate(['/']);
                }
            } else {
                this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
                this.router.navigate(['/']);
              }
        },
        (err: HttpErrorResponse) => {
            this.isValidating = false;
            this.sharedFunctions.handleError(err, true);
        });
    }

    loadView() {
        this.canView = true;
        this.buildForm();

        this.getCategorias();
        this.getComunidades();

        this.pageSizes = GridPageSettings.PageSizeList;
        this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };


        this.setQueryParams();
        this.data = new DataManager({
            url: this.service.getServiceUrl() + '/search-self',
            adaptor: new WebApiAdaptor(),
            headers: [this.service.getAuthorizationHeader(), this.service.getTenantHeader()]
        });

        this.menuService.checkMenu(MenuFuncionCodes.INCIDENCIA_USUARIO_EDIT).subscribe(data => {
            this.isValidating = false;
            if (data != null && data.Success && data?.Result)
                this.canEdit = true;
        },
        (err: HttpErrorResponse) => {
            this.sharedFunctions.handleError(err);
        });
    }

    buildForm() {
        this.searchForm = this.formBuilder.group({
            'UsuarioCreador': [null],
            'UsuarioDestino': [null],
            'FechaCreacionDesde': [null],
            'FechaCreacionHasta': [null],
            'Asunto': [null],
            'Id': [null],
            'ComunidadId': [null],
            'IncidenciaUsuarioCategoriaId': [null]
        });
    }

    getCategorias() {
        var r = new SearchIncidenciaUsuarioCategoriaRequest(null, null, true, "Nombre", null, null, true, false);
        this.isCategoriaSearching = true;

        this.categoriaService.search(r).subscribe(data => {
            this.isCategoriaSearching = false;
            this.categoriaList = data?.result;
        },
        (err: HttpErrorResponse) => {
            this.isCategoriaSearching = false;
            this.sharedFunctions.handleError(err);
        })
    }

    getComunidades() {
        var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
        if (cId != null && cId.length > 0 && cId > 0)
            cId = Number(cId);

        var r = new SearchComunidadRequest(null, null, true, "Nombre", null, cId, null, null, null, true);
        this.isComunidadSearching = true;

        this.comunidadService.search(r).subscribe(data => {
          this.isComunidadSearching = false;
          if (data != null)
            this.comunidadList = data?.result;
        },
        (err: HttpErrorResponse) => {
          this.isComunidadSearching = false;
          this.sharedFunctions.handleError(err);
        });
    }

    onSearch() {
        this.setQueryParams();
        this.grid.refresh();
    }

    onSentSearch() {
        this.verEnviados = !this.verEnviados;
        this.verSoloNoLeidos = false;
        this.onSearch();
    }

    setQueryParams() {
        if (this.query == null)
            this.query = new Query();

        var index = this.query.params.findIndex(obj => obj.key === "VerEnviados");
        if (index >= 0)
            this.query.params[index].value = this.verEnviados.toString();
        else
            this.query.addParams("VerEnviados", this.verEnviados.toString());

        index = this.query.params.findIndex(obj => obj.key === "VerSoloNoLeidos");
        if (index >= 0)
            this.query.params[index].value = this.verSoloNoLeidos.toString();
        else
            this.query.addParams("VerSoloNoLeidos", this.verSoloNoLeidos.toString());

        index = this.query.params.findIndex(obj => obj.key === "FechaCreacionDesde");
        if (index >= 0)
            this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaCreacionDesde, "yyyy-MM-dd");
        else
            this.query.addParams("FechaCreacionDesde", this.datePipe.transform(this.searchForm.value.FechaCreacionDesde, "yyyy-MM-dd"));

        index = this.query.params.findIndex(obj => obj.key === "FechaCreacionHasta");
        if (index >= 0)
            this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaCreacionHasta, "yyyy-MM-dd");
        else
            this.query.addParams("FechaCreacionHasta", this.datePipe.transform(this.searchForm.value.FechaCreacionHasta, "yyyy-MM-dd"));

        index = this.query.params.findIndex(obj => obj.key === "ComunidadId");
        if (index >= 0)
            this.query.params[index].value = this.searchForm.value.ComunidadId;
        else
            this.query.addParams("ComunidadId", this.searchForm.value.ComunidadId);

        index = this.query.params.findIndex(obj => obj.key === "Id");
        if (index >= 0)
            this.query.params[index].value = this.searchForm.value.Id;
        else
            this.query.addParams("Id", this.searchForm.value.Id);

        index = this.query.params.findIndex(obj => obj.key === "IncidenciaUsuarioCategoriaId");
        if (index >= 0)
            this.query.params[index].value = this.searchForm.value.IncidenciaUsuarioCategoriaId;
        else
            this.query.addParams("IncidenciaUsuarioCategoriaId", this.searchForm.value.IncidenciaUsuarioCategoriaId);

        // index = this.query.params.findIndex(obj => obj.key === "UsuarioCreador");
        // if (index >= 0)
        //     this.query.params[index].value = this.searchForm.value.UsuarioCreador;
        // else
        //     this.query.addParams("UsuarioCreador",this.searchForm.value.UsuarioCreador);

        // index = this.query.params.findIndex(obj => obj.key === "UsuarioDestino");
        // if (index >= 0)
        //     this.query.params[index].value = this.searchForm.value.UsuarioDestino;
        // else
        //     this.query.addParams("UsuarioDestino",this.searchForm.value.UsuarioDestino);

        index = this.query.params.findIndex(obj => obj.key === "Asunto");
        if (index >= 0)
            this.query.params[index].value = this.searchForm.value.Asunto;
        else
            this.query.addParams("Asunto", this.searchForm.value.Asunto);
    }

    clearDate(formFieldName: string) {
        if (formFieldName != null && formFieldName.length > 0) {
            if (this.searchForm.get(formFieldName) != null && this.searchForm.get(formFieldName)?.value)
                this.searchForm.get(formFieldName)?.setValue(null);
        }
    }

    add() {
        if (this.canEdit)
            this.router.navigate(['incidencia-usuario-edit', 0]);
        else
            this.sharedFunctions.showMessage("No puede ejecutar esta operación", "Error");
    }

    view(item: SearchIncidenciaUsuarioItemDto) {
        if (!item || item.Id == null || item.Id <= 0) {
            this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
            return false;
        }

        if (this.verEnviados) {
            var loggedUser = this.sharedFunctions.getLoggedUser();

            if (loggedUser?.Id != null && loggedUser.Id > 0) {
                if (loggedUser.Id == item.UsuarioCreadorId && !item.Enviado)
                    this.router.navigate(['incidencia-usuario-edit', item.Id]);
                else
                    this.openMessage(item);
            }
        }
        else
            this.openMessage(item);
    }

    openMessage(item: SearchIncidenciaUsuarioItemDto) {
        this.router.navigate(['incidencia-usuario-edit', item.Id]);
    }

    onExport() {
        var search = new SearchIncidenciaUsuarioRequestDto(null, null, null, "", null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null);
        search = Object.assign(search, this.searchForm.value);

        this.isExporting = true;
        this.service.exportMySearch(search).subscribe((data: Blob) => {
            this.isExporting = false;
            var fileUrl = URL.createObjectURL(data);

            var anchor = document.createElement("a");
            anchor.download = "IncidenciaUsuarios_" + this.datePipe.transform(new Date(), "yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
            anchor.href = fileUrl;
            anchor.click();
        },
            (err: HttpErrorResponse) => {
                this.isExporting = false;
                this.sharedFunctions.handleError(err, true);
            })
    }
}
